import React, { useState } from 'react'
import { BrowserRouter as Router, Routes, Route, Link, useNavigate } from 'react-router-dom';
import './App.css'

// import AIBotWrapper from './pages/AIBotWrapper.js';
// import UploadWrapper from './pages/UploadWrapper.js';
// import Home from './pages/Home.js';
import Sidebar from './pages/Sidebar.js';
import { UploadProvider } from './contexts/UploadContext.js';

import { PageLayout } from './components/Auth/PageLayout';
import MainContent from './pages/MicrosoftAuthWrapper.js';
import { AuthProvider } from './contexts/AuthContext.js';
import AzureOpenAIWrapper from './pages/AzureOpenAIWrapper.js';
import UploadedFile from './hooks/UseDragAndDrop.js';
import { ClientProvider } from './contexts/ClientContext.js';
import { OrderProvider } from './contexts/OrderContext.js';
import { ProjectProvider } from './contexts/ProjectContext.js';
import { NewChatProvider } from './contexts/NewChatContext.js';
import { SocketProvider } from './contexts/SocketContext.js';
import NotificationCenter from './components/NotificationCenter.js';

import RTCNotificationsListener from './components/MeetingNotificationsListener';
import CallOverlay from './pages/CallOverlay.js';


// export default function App() {
//   return (
//       <PageLayout>
//           <center>
//               <MainContent />
//           </center>
//       </PageLayout>
//   );
// }


const App = () => {


  return (
    <>
      <SocketProvider>
        <NewChatProvider>
          <AuthProvider>
            <ProjectProvider>
              <ClientProvider>
                <OrderProvider>
                  <UploadProvider>
                    {/* <DropdownProvider> */}
                    <NotificationCenter />
                    <RTCNotificationsListener />
                    <CallOverlay />
                    <Sidebar />
                    {/* <AzureOpenAIWrapper /> */}
                    {/* <UploadedFile /> */}
                    {/* </DropdownProvider> */}
                  </UploadProvider>
                </OrderProvider>
              </ClientProvider>
            </ProjectProvider>
          </AuthProvider>
        </NewChatProvider>
      </SocketProvider>
      {/* <button label="test">Test</button> */}

      {/* <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/aibot" element={<AIBotWrapper />} />
          <Route path="/upload" element={<UploadWrapper />} />
        </Routes>
      </Router> */}


      {/* <Home />
      <AIBotWrapper />
      <UploadWrapper /> */}

    </>
  );
}

export default App;
